import RemoteCall from "../../../util/RemoteCall";

const remoteCall = new RemoteCall("api/wsjkw/setting");

const findUserTreeAsync = (param) => {
    return remoteCall.invoke("findUserTree", param);
};

export default {
    findUserTreeAsync,
};
